import { createElement, FC, PropsWithChildren } from 'react';
import { View } from 'react-native';

export const PreviousNextView: FC<PropsWithChildren> = ({
  children,
  ...props
}) => createElement(View, props, children);

export default null;
